import React, { useContext, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { DeleteModal } from '../../../../../../components/DeleteModal';
import { DeletePayoutProfileModalContext } from './DeletePayoutProfileModalContext';
import { ToastContext } from '@weezevent/nacre';
import { useStore } from '../../../store';
import PropTypes from 'prop-types';

export const DeletePayoutProfileProvider = ({ children }) => {
    const [openedId, setOpenedId] = useState(null);
    const { payoutProfiles } = useStore();
    const { t } = useTranslation();
    const entity = openedId ? payoutProfiles.getById(openedId) : null;
    const toaster = useContext(ToastContext);

    const closeModal = () => {
        setOpenedId(null);
    };

    const deleteMutation = useMutation(
        () => {
            return payoutProfiles.delete(openedId);
        },
        {
            onSuccess: () => {
                closeModal();
                toaster.success(
                    t('sauron.financeModule.payoutProfiles.deleteModal.successToast', {
                        name: entity?.name
                    })
                );
            }
        }
    );

    const value = useMemo(() => {
        return {
            open: setOpenedId
        };
    }, []);

    return (
        <DeletePayoutProfileModalContext.Provider value={value}>
            <DeleteModal
                onSubmit={deleteMutation.mutate}
                onCancel={closeModal}
                isSubmitting={deleteMutation.isLoading}
                open={!!openedId}
                title={t('sauron.financeModule.payoutProfiles.deleteModal.title', {
                    name: entity?.name
                })}
                description={t('sauron.financeModule.payoutProfiles.deleteModal.description')}
            ></DeleteModal>
            {children}
        </DeletePayoutProfileModalContext.Provider>
    );
};

DeletePayoutProfileProvider.propTypes = {
    children: PropTypes.node
};
